export default __webpack_public_path__ + "icon-like.12011d23.png";